<template>
  <div v-if="shelf || books.length > 0">
    <h2>
      <editable-text
        v-if="!embed && isMyShelf && shelf"
        :to="`/user/${user.username}/shelf/${shelfDetail.label}`"
        :initialText="shelfDetail.custom || shelfDetail.description"
        :update="updateShelfDescription"
        :id="shelfDetail.label"
      ></editable-text>
      <span v-else>{{ shelfDetail.custom || shelfDetail.description }}</span>
      <router-link v-if="isMyShelf && !embed" :to="`/add-book`">
        (<i class="fa fa-plus"></i>)</router-link
      >
    </h2>
    <ul v-if="books.length === 0 && isMyShelf" class="bookDetailsList">
      <li class="bookDetailsItem">
        <a href="/add-book" class="add-book-link">Add books to this shelf</a>
      </li>
    </ul>
    <div v-else>
      <draggable
        v-if="isMyShelf && !embed && !count"
        v-model="books"
        tag="ul"
        class="bookDetailsList"
        group="books"
        @start="drag = true"
        @end="orderBooksOnShelf"
      >
        <li
          class="bookDetailsItem"
          v-for="book in filteredBooks"
          :key="book.book"
        >
          <publication-details :publication="book"></publication-details>
        </li>
      </draggable>
      <ul v-else class="bookDetailsList">
        <li class="bookDetailsItem" v-for="book in books" :key="book.book">
          <publication-details :publication="book"></publication-details>
        </li>
        <li class="bookDetailsItem" v-if="this.count === books.length">
          <router-link
            :to="`/user/${user.username}/shelf/${shelfDetail.label}`"
          >
            <div class="bookEnd">
              <p>More books</p>
            </div>
          </router-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import draggable from 'vuedraggable';
import PublicationDetails from './PublicationDetails';
import EditableText from './EditableText';

export default {
  name: 'shelf',
  components: {
    'editable-text': EditableText,
    'publication-details': PublicationDetails,
    draggable,
  },
  computed: {
    isMyShelf() {
      return (
        this.user &&
        this.user.username &&
        this.token &&
        this.tokenUser &&
        this.user.username === this.tokenUser.username
      );
    },
    filteredBooks() {
      if (this.filter === '') {
        return this.books;
      }
      return this.books.filter(
        (book) =>
          book.title.toLowerCase().indexOf(this.filter.toLowerCase()) >= 0 ||
          book.authors.filter(
            (author) =>
              author.name.toLowerCase().indexOf(this.filter.toLowerCase()) >= 0,
          ).length > 0,
      );
    },
  },
  props: ['shelf', 'user', 'count', 'filter'],
  created() {
    this.$eventHub.$on('refresh-shelves', () => {
      this.getShelf();
    });
  },
  beforeDestroy() {
    this.$eventHub.$off('refresh-shelves');
  },
  data() {
    return {
      embed:
        !(typeof this.$route.query.embed === 'undefined') &&
        this.$route.query.embed !== 'false',
      books: [],
      token: this.$cookies.get('user'),
      shelfDetail: {},
      tokenUser: {},
    };
  },
  mounted() {
    this.getShelf();
    this.getUser();
  },
  methods: {
    async getShelf() {
      if (this.shelf) {
        axios
          .get(
            `/user/${this.user.username}/shelf/${this.shelf.label}${
              this.count ? `?count=${this.count}` : ''
            }`,
            {
              headers: {
                Authorization: `Bearer ${this.token}`,
              },
            },
          )
          .then((response) => {
            this.books = response.data.books;
            this.shelfDetail = response.data.shelf;
          });
      } else {
        axios
          .get(
            `/user/${this.user.username}/unshelved${
              this.count ? `?count=${this.count}` : ''
            }`,
            {
              headers: {
                Authorization: `Bearer ${this.token}`,
              },
            },
          )
          .then((response) => {
            this.books = response.data;
            this.shelfDetail = {
              label: 'unshelved',
              description: 'Unshelved books',
            };
          });
      }
    },
    async getUser() {
      return axios
        .get(`/user`, {
          headers: {
            Authorization: `Bearer ${this.token}`,
          },
        })
        .then((response) => (this.tokenUser = response.data));
    },
    orderBooksOnShelf() {
      axios.post(
        `/user/${this.user.username}/shelf/${this.shelf.label}`,
        this.books.map((book) => book.bookId),
        {
          headers: {
            Authorization: `Bearer ${this.token}`,
          },
        },
      );
    },
    updateShelfDescription(newName) {
      axios.put(
        `/user/${this.user.username}/shelf/${this.shelf.label}`,
        {
          description: newName,
        },
        {
          headers: {
            Authorization: `Bearer ${this.token}`,
          },
        },
      );
    },
  },
};
/*
<iframe src="http://localhost:5000/user/thingsinjars/shelf/non-fiction?embed"
        width="100%" height="350" frameborder="0">
  <p> <a href="http://localhost:5000/user/thingsinjars/shelf/non-fiction?embed">
    Shelvist Embedded Shelf
  </a> </p>
</iframe>
*/
</script>
